import {BaseEventTrackerWrapper, EventName, ExtraData} from './BaseEventTrackerWrapper';

export class NullEventTracker extends BaseEventTrackerWrapper {
    public init(): void {}
    public tag(event: EventName, extraData?: ExtraData): void {}
}